import { Typography } from '@mui/material';
import { useEffect, useState } from 'react';

import { prListStorage } from '../../../../services/workStorage';
import S from './styled';

type Props = {
    onChange: (urls: string[]) => void;
    showLabel?: boolean;
    value?: string[];
    resetKey?: number;
    workId?: number;
};

const AddPullRequest: React.FC<Props> = ({ onChange, showLabel = true, value = [], resetKey = 0, workId }) => {
    const [ prList, setPrList ] = useState<string[]>(value);
    
    // Clear local state when the work session resets
    useEffect(() => {
        if (resetKey !== undefined && workId) {
            setPrList([]);
            onChange([]);
            prListStorage.clear(workId);
        }
    }, [ resetKey, onChange, workId ]);
    
    // Sync with external value prop from WebSocket
    useEffect(() => {
        if (value && value.length > 0) {
            setPrList(prevList => {
                const newUrls = value.filter(url => !prevList.includes(url));
                if (newUrls.length > 0) {
                    const updatedList = [ ...prevList, ...newUrls ];
                    onChange(updatedList);
                    return updatedList;
                }
                return prevList;
            });
        }
    }, [ value, onChange ]);

    useEffect(() => {
        if (!workId) {
            return;
        }
        prListStorage.save(workId, prList);
    }, [ prList, workId ]);

    return (
        <S.Root>
            {showLabel && (
                <Typography sx={S.labelTitle} component="label">
                    PR List
                </Typography>
            )}
            <S.PrListContainer>
                {prList.length === 0 ? (
                    <Typography sx={S.emptyMessage}>
                        No PRs yet. PRs will appear here automatically when created.
                    </Typography>
                ) : (
                    prList.map((url, idx) => (
                        <S.PrItem key={idx}>
                            <Typography sx={S.prUrl}>{url}</Typography>
                        </S.PrItem>
                    ))
                )}
            </S.PrListContainer>
        </S.Root>
    );
};

export default AddPullRequest;
